document.addEventListener("alpine:init", () => {
  Alpine.data("mainProductSubscription", (element, sectionID) => ({
    init() {
      this.stickyATC = false;
      this.currentVariantId = Number(element.dataset.currentVariantId);
      this.currentVariantTitle = element.dataset.currentVariantTitle;
      this.currentVariantPrice = element.dataset.currentVariantPrice;
      this.currentVariantCompareAtPrice =
        element.dataset.currentVariantCompareAtPrice;
      this.handle = element.dataset.productHandle;
      this.productGallery =
        document.querySelector("#product-gallery").innerHTML;
      this.productQuantity = 1;
      this.freeGiftId = Number(element.dataset.freeGiftId);
      this.totalPrice = "";
      this.initSlider();
      this.initVideoPlay();
      this.initVideoSlider();

      // Hide gallery spinners on initial load
      this._initSpinnerHideTimeout = setTimeout(() => {
        const el = document.querySelector("#product-gallery");
        if (el) {
          el.querySelectorAll(".loading-spinner").forEach((s) => {
            s.style.display = "none";
          });
        }
        this._initSpinnerHideTimeout = null;
      }, 100);
    },

    initSlider() {
      if (window.innerWidth > 999) {
        this.thumbs = new Swiper(this.$refs.sliderThumbs, {
          slidesPerView: "auto",
          spaceBetween: 8,
          mousewheel: {
            releaseOnEdges: true,
          },
        });
      }
      this.main = new Swiper(this.$refs.sliderMain, {
        slidesPerView: "auto",
        spaceBetween: 16,
        loop: true,
        speed: 1000,
        thumbs: {
          swiper: this.thumbs,
        },
        pagination: {
          el: this.$refs.pagination,
          clickable: true,
        },
        navigation: {
          nextEl: document.querySelector(".swiper-button-prev-custom"),
          prevEl: document.querySelector(".swiper-button-next-custom"),
        },
        breakpoints: {
          1000: {
            // At width >= 1000px, disable pagination
            pagination: false,
          },
        },
      });
    },

    updateSliderImages(variantId) {
      const slides = document.querySelectorAll(".swiper-slide[variant-id]");

      slides.forEach((slide) => {
        if (Number(slide.getAttribute("variant-id")) !== variantId) {
          slide.remove();
        }
      });
    },
    async fetchGallery() {
      const productGallery = document.querySelector("#product-gallery");
      if (!productGallery) return;

      // Clear any previous hide timeout and init hide timeout
      if (this._gallerySpinnerHideTimeout != null) {
        clearTimeout(this._gallerySpinnerHideTimeout);
        this._gallerySpinnerHideTimeout = null;
      }
      if (this._initSpinnerHideTimeout != null) {
        clearTimeout(this._initSpinnerHideTimeout);
        this._initSpinnerHideTimeout = null;
      }

      const galleryHeight = productGallery.offsetHeight;
      productGallery.style.height = `${galleryHeight}px`;

      productGallery.innerHTML = this.productGallery;

      this._gallerySpinnerHideTimeout = setTimeout(() => {
        // Hide spinners first (scoped to gallery only)
        productGallery
          .querySelectorAll(".loading-spinner")
          .forEach((spinner) => {
            spinner.style.display = "none";
          });

        // Then clear height (in try/catch so hide always runs even if this throws)
        try {
          productGallery.style.height = "";
        } catch (_) {}

        this._gallerySpinnerHideTimeout = null;
      }, 2000);
    },

    updateSticky(title) {
      if (Alpine.store("sync").isSyncing) return;
      Alpine.store("sync").isSyncing = true;

      const stickyInput = document.querySelector(
        `#stickyATC input[value="${title}"]`,
      );

      stickyInput.checked = true;
      stickyInput.dispatchEvent(new Event("change", { bubbles: false }));

      Alpine.store("sync").isSyncing = false;
    },

    initVideoPlay() {
      const videoWrappers = document.querySelectorAll(".video-wrapper");
      if (!videoWrappers.length) return;

      videoWrappers.forEach(function (videoWrapper) {
        const posterImageWrapper = videoWrapper.querySelector(
          ".poster-image-wrapper",
        );
        const videoElement = videoWrapper.querySelector("video");

        if (posterImageWrapper && videoElement) {
          posterImageWrapper.addEventListener("click", function () {
            posterImageWrapper.style.display = "none";
            videoElement.play();
            videoElement.classList.remove("hidden");
          });

          videoElement.addEventListener("play", function () {
            posterImageWrapper.style.display = "none";
          });

          videoElement.addEventListener("pause", function () {
            if (videoElement.currentTime === 0 || videoElement.ended) {
              posterImageWrapper.style.display = "flex";
            }
          });
        }
      });
    },
    initVideoSlider() {
      if (!this.$refs.videoSlider) return;
      this.videoSlider = new Swiper(this.$refs.videoSlider, {
        slidesPerView: "auto",
        spaceBetween: 16,
        loop: true,
        speed: 1000,
      });

      if (!this.$refs.videoSliderDesktop) return;
      this.videoSlider = new Swiper(this.$refs.videoSliderDesktop, {
        slidesPerView: "auto",
        spaceBetween: 16,
        loop: true,
        speed: 1000,
      });
    },
    handleCheckbox(el, id, name) {
      const product_variants = JSON.parse(
        document.querySelector("#product-variants")?.textContent || "{}",
      );

      // const product = await api.getProduct(handle);
      var selectedOption = [];

      document
        .getElementById("product_options")
        .querySelectorAll('input[type="radio"]:checked')
        .forEach((radio) => {
          selectedOption.push(radio.value);
        });

      var matchedVariant = product_variants.find((variant) => {
        var pass = true;
        for (var i = 0; i < selectedOption.length; i++) {
          if (selectedOption.indexOf(variant.options[i]) === -1) {
            pass = false;
            break;
          }
        }
        return pass;
      });

      console.log(matchedVariant);

      const matchedSellingPlan = matchedVariant.selling_plan_allocations.find(
        (plan) => plan.selling_plan_id == id,
      );

      console.log(el.checked);
      console.log(id);
      console.log(name);
      if (el.checked) {
        this.subscriptionId = id;
        this.subsciptionPlan = name;
        this.purchaseType = "Subscription";
        this.currentVariantPrice = matchedSellingPlan.price;
        this.totalPrice = matchedSellingPlan.price * this.productQuantity;
      } else {
        this.subscriptionId = null;
        this.subsciptionPlan = "";
        this.purchaseType = "OneTime";
        this.currentVariantPrice = matchedVariant.price;
        this.totalPrice = matchedVariant.price * this.productQuantity;
      }
    },
  }));

  Alpine.data("productOptions", (element, handle) => ({
    init() {
      this.findMatchingVariant();
    },

    async findMatchingVariant() {
      console.log(element);

      const response = await fetch(
        window.Shopify.routes.root + `products/${handle}.js`,
      );
      const product = await response.json();

      var selectedOption = [];
      element
        .querySelectorAll('input[type="radio"]:checked')
        .forEach((radio) => {
          selectedOption.push(radio.value);
        });
      var matchedVariant = product.variants.find((variant) => {
        var pass = true;
        for (var i = 0; i < selectedOption.length; i++) {
          if (selectedOption.indexOf(variant.options[i]) === -1) {
            pass = false;
            break;
          }
        }
        return pass;
      });

      console.log(matchedVariant);

      this.currentVariantId = Number(matchedVariant.id);
      this.currentVariantTitle = matchedVariant.title;
      this.currentVariantCompareAtPrice = matchedVariant.compare_at_price;

      this.fetchGallery();
      this.updateSliderImages(matchedVariant.id);
      this.updateSticky(this.currentVariantTitle);

      const matchedSellingPlan = matchedVariant.selling_plan_allocations.find(
        (plan) => plan.selling_plan_id == this.subscriptionId,
      );
      console.log(matchedSellingPlan);

      if (this.purchaseType == "OneTime") {
        this.totalPrice = matchedVariant.price * this.productQuantity;
        this.currentVariantPrice = matchedVariant.price;
      } else {
        this.totalPrice = matchedSellingPlan.price * this.productQuantity;
        this.currentVariantPrice = matchedSellingPlan.price;
      }

      setTimeout(() => {
        this.initSlider();
      }, 200);
    },
  }));

  Alpine.data("productOptionsFromSticky", (el, handle) => ({
    async handleOptionClickSticky(value) {
      if (Alpine.store("sync").isSyncing) return;

      Alpine.store("sync").isSyncing = true;

      const checkbox = document.querySelector(
        `#product_options input[value="${value}"]`,
      );
      if (checkbox) {
        checkbox.checked = true;
        checkbox.dispatchEvent(new Event("change", { bubbles: true }));
      }

      Alpine.store("sync").isSyncing = false;
    },
  }));
});
